"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OneToOne = exports.ManyToMany = exports.ForeignKey = undefined;

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

exports.fk = fk;
exports.many = many;
exports.oneToOne = oneToOne;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Field = function Field(toModelName, relatedName) {
    (0, _classCallCheck3.default)(this, Field);

    this.toModelName = toModelName;
    this.relatedName = relatedName;
};

var ForeignKey = exports.ForeignKey = function (_Field) {
    (0, _inherits3.default)(ForeignKey, _Field);

    function ForeignKey() {
        (0, _classCallCheck3.default)(this, ForeignKey);
        return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ForeignKey).apply(this, arguments));
    }

    return ForeignKey;
}(Field);
var ManyToMany = exports.ManyToMany = function (_Field2) {
    (0, _inherits3.default)(ManyToMany, _Field2);

    function ManyToMany() {
        (0, _classCallCheck3.default)(this, ManyToMany);
        return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(ManyToMany).apply(this, arguments));
    }

    return ManyToMany;
}(Field);
var OneToOne = exports.OneToOne = function (_Field3) {
    (0, _inherits3.default)(OneToOne, _Field3);

    function OneToOne() {
        (0, _classCallCheck3.default)(this, OneToOne);
        return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(OneToOne).apply(this, arguments));
    }

    return OneToOne;
}(Field);

function fk() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    return new (Function.prototype.bind.apply(ForeignKey, [null].concat(args)))();
}

function many() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
    }

    return new (Function.prototype.bind.apply(ManyToMany, [null].concat(args)))();
}

function oneToOne() {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
    }

    return new (Function.prototype.bind.apply(OneToOne, [null].concat(args)))();
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-orm/lib/fields.js
 ** module id = 560
 ** module chunks = 0
 **/